import { addCache } from 'api/caching'
import { getCerebroHeaders } from 'api/Cerebro/headers'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { Report } from 'types'

import { BannerRequestBody } from './types'

/**
 * Gets relevant SC Sales and Traffic data, grouped and filtered
 * by specified parameters
 */
export const getScSalesAndTrafficData = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post(
        '/api/seller_central_sales_and_traffic_facts/aggregate/banner/',
        params,
        { headers: getCerebroHeaders(options.headers) }
    )

/**
 * Get a CSV export for SC Sales and Traffic, grouped and filtered
 * by specified parameters
 */
export const getScSalesAndTrafficDataExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        '/api/seller_central_sales_and_traffic_facts/aggregate/banner/export/',
        params
    )

/**
 * Gets relevant SC Seller Analytics data, grouped and filtered
 * by specified parameters
 */
export const getScSellerAnalyticsData = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post(
        '/api/seller_central_seller_analytics_facts/aggregate/banner/',
        params,
        { headers: getCerebroHeaders(options.headers) }
    )

/**
 * Get a CSV export for SC Seller Analytics, grouped and filtered
 * by specified parameters
 */
export const getScSellerAnalyticsDataExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        '/api/seller_central_seller_analytics_facts/aggregate/banner/export/',
        params
    )

/**
 * Gets relevant SC Order Metrics & Metadata, grouped and filtered
 * by specified parameters
 */
export const getScOrderV2Metrics = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post(
        '/api/seller_central_order_facts/aggregate/banner/',
        params,
        { headers: getCerebroHeaders(options.headers) }
    )
addCache(getScOrderV2Metrics)

/**
 * Get a CSV export for SC Order Metrics & Metadata, grouped and filtered
 * by specified parameters
 */
export const getScOrderV2MetricsExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        '/api/seller_central_order_facts/aggregate/banner/export/',
        params
    )
